// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_40b78b6","hover":"_2e4e6ca"};